module.exports = __webpack_public_path__ + "img/notfound.228e4ee9.svg";